import { createFileRoute, Link } from '@tanstack/react-router';
import { MarketingLayout } from '@/components/marketing/MarketingLayout';
import { Seo } from '@/components/marketing/Seo';
import { StoreBadges } from '@/components/marketing/StoreBadges';
import { track } from '@/lib/analytics';

export const Route = createFileRoute('/pricing')({ component: PricingPage });

export function PricingPage() {
  return (
    <MarketingLayout screen="Pricing Screen">
      <Seo
        title="Hmonglus Premium"
        description="Unlock every Hmonglus story, crossword, lesson, and premium game on the web, iPhone, and Android."
        path="/pricing"
      />
      <main className="bg-sky-light px-6 pb-24 pt-32">
        <div className="mx-auto max-w-4xl">
          <div className="text-center">
            <p className="text-lg font-semibold text-primary">Hmonglus Premium</p>
            <h1 className="mt-3 font-khula text-5xl font-light text-gray-900 md:text-6xl">Keep learning without limits.</h1>
            <p className="mx-auto mt-5 max-w-2xl text-lg text-gray-600">
              Unlock the complete crossword archive, premium stories and lessons, sticker packs, Nab, and everything we add next.
            </p>
          </div>
          <section className="relative mx-auto mt-12 max-w-xl rounded-2xl border-2 border-primary bg-white p-8">
            <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-primary px-4 py-1 text-sm font-medium text-white">
              Most popular
            </span>
            <ul className="space-y-4">
              {[
                'All premium learning content',
                'Crosswords and puzzle archive',
                'Premium games and sticker packs',
                'One subscription across web, iPhone, and Android',
              ].map((feature) => (
                <li key={feature} className="flex gap-3 font-semibold text-gray-700">
                  <span className="text-primary">✓</span>
                  {feature}
                </li>
              ))}
            </ul>
            <Link
              to="/app/subscribe"
              onClick={() => track('Landing CTA Press', { cta: 'pricing-plans' })}
              className="mt-8 block rounded-lg bg-primary px-6 py-3 text-center font-semibold text-white hover:bg-primary-hover"
            >
              View plans
            </Link>
            <p className="mt-4 text-center text-xs leading-5 text-gray-500">
              Secure checkout is provided by Stripe. Cancel anytime.
            </p>
          </section>
          <div className="mx-auto mt-12 max-w-xl">
            <p className="mb-4 text-center font-semibold text-gray-600">Prefer the mobile app?</p>
            <StoreBadges source="pricing" />
          </div>
        </div>
      </main>
    </MarketingLayout>
  );
}
